import { HashConnect } from "hashconnect";
import { BASE_URL } from '../apiConfig';
import { authFetch, handleAuthResponse } from '../../utils/authFetch';

export const getAllProperties = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  // Use plain fetch (not authFetch) - this endpoint uses a static API key, not JWT.
  // Using authFetch caused any 401 from this endpoint to incorrectly log the user out,
  // which happened every time the saga dispatched getPropertiesReducer() after saving a product.
  const response = await fetch(
    `${BASE_URL}/getAllProductList?language=${language}`,
    options
  );
  return response.json();
};

export const getRecentTransactionAPI = async (id) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return await authFetch(
    "https://testnet.mirrornode.hedera.com/api/v1/transactions?account.id=" +
      id,
    options
  ).then(handleAuthResponse);
};

export const associateTokenAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://2v445l6fn75glpuq2nuwihq4wu0tmzjk.lambda-url.ap-southeast-1.on.aws/associatetoken",
    options
  ).then(handleAuthResponse);
};

export const transferTokenApi = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://2v445l6fn75glpuq2nuwihq4wu0tmzjk.lambda-url.ap-southeast-1.on.aws/transfernfttoken",
    options
  ).then(handleAuthResponse);
};

export const getWalletBalance = async () => {
  let hashconnect = new HashConnect();
  let appMetadata = {
    name: "dApp Example",
    description: "An example hedera dApp",
    icon: "https://absolute.url/to/icon.png",
  };

  let initData = await hashconnect.init(appMetadata, "testnet", false);

  if (initData.savedPairings) {
    let provider = hashconnect.getProvider(
      "testnet",
      initData.topic,
      initData.savedPairings[0].accountIds[0]
    );
    let balance = await provider.getAccountBalance(
      initData.savedPairings[0].accountIds[0]
    );
    console.log("Waller", balance.hbars._valueInTinybar.toNumber());
    return balance.hbars._valueInTinybar.toNumber();
  } else {
    return "Not Linked";
  }
};

export const SavePropertiesAPI = async (payload) => {
  const { property_img, ...payloadWithoutImage } = payload; // Destructure the property_img from the payload

  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payloadWithoutImage), // Use the payload without the property_img
  };

  const response = await authFetch(`${BASE_URL}/addLot`, options);

  // authFetch returns a plain object (not a Response) when it handles a 401
  if (response.error && response.status === 401) {
    return response;
  }

  const data = await response.json();

  // If the first POST request is successful, make the second POST request to localhost
  if (response.ok) {
    // Assume success by default
    let uploadSuccess = true;

    try {
      // Use plain fetch (not authFetch) - loadImage uses a static API key, not JWT.
      // Using authFetch here caused any 401 from the image server to incorrectly
      // log the user out even though the product was already saved successfully.
      const uploadResponse = await fetch("https://api.vertocommodities.io/loadImage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "abc123",
          apikey: "abc123",
        },
        body: JSON.stringify({ productID: data.productID, property_img }),
      });

      if (uploadResponse.status === 413) {
        throw new Error("Picture is too large");
      } else if (!uploadResponse.ok) {
        throw new Error("Failed to upload image to API");
      }
    } catch (uploadError) {
      // If there is an error in image upload, set uploadSuccess to false
      uploadSuccess = false;
      console.error("Image upload error:", uploadError.message);
    }

    // Attach the uploadSuccess information to the response data
    data.uploadSuccess = uploadSuccess;
  }

  return data;
};

export const SaveDraftPropertiesAPI = async (payload) => {
  const { property_img, ...payloadWithoutImage } = payload; // Destructure the property_img from the payload

  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payloadWithoutImage), // Use the payload without the property_img
  };

  const response = await authFetch(
    `${BASE_URL}/addDraftLot`, 
    options
  );

  const data = await response.json();

  // If the first POST request is successful, make the second POST request to localhost
  if (response.ok) {
    try {
      // Use plain fetch (not authFetch) - loadImage uses a static API key, not JWT.
      const uploadResponse = await fetch("https://api.vertocommodities.io/loadImage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "abc123",
          apikey: "abc123",
        },
        body: JSON.stringify({ productID: data.productID, property_img }),
      });
      
      if (uploadResponse.status === 413){
        throw new Error("Picture is too large");
      }
    } catch (uploadError) {
      console.error("Draft image upload error:", uploadError.message);
    }
  }

  return data;
};

export const DeleteDraftPropertiesAPI = async (payload) => {
  const { property_img, ...payloadWithoutImage } = payload; // Destructure the property_img from the payload

  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payloadWithoutImage), // Use the payload without the property_img
  };

  const response = await authFetch(
    `${BASE_URL}/deleteDraftLot`, 
    options
  );

  const data = await response.json();

  return data;
};

export const loadLotImageAPI = async (payload) => {

  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };

  const response = await authFetch(
    `${BASE_URL}/loadImage`, 
    options
  );

  const data = await response.json();

  return data;
};

export const CreateNFTAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://2v445l6fn75glpuq2nuwihq4wu0tmzjk.lambda-url.ap-southeast-1.on.aws/createnfttoken",
    options
  ).then(handleAuthResponse);
};

export const getAccountIdApi = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify({
      userId: payload,
    }),
  };
  return await authFetch(
    "https://2v445l6fn75glpuq2nuwihq4wu0tmzjk.lambda-url.ap-southeast-1.on.aws/getaccountinfo",
    options
  ).then(handleAuthResponse);
};

export const addCommercialContractAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/addcommercialcontract",
    options
  ).then(handleAuthResponse);
};

export const createCommercialContractAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/createcommercial",
    options
  ).then(handleAuthResponse);

};

export const allSubjectsLiftedAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/allsubjectslifted",
    options
  ).then(handleAuthResponse);
};

export const createContractAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/initcontract",
    options
  ).then(handleAuthResponse);
};

export const sellerSignAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/sellersign",
    options
  ).then(handleAuthResponse);
};

export const buyerSignAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/buyersign",
    options
  ).then(handleAuthResponse);
};

export const updateCommercialAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updatecommercial",
    options
  ).then(handleAuthResponse);
};

export const confirmBySellerAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/confirmbyseller",
    options
  ).then(handleAuthResponse);
};

export const confirmByBuyerAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/confirmbybuyer",
    options
  ).then(handleAuthResponse);
};

export const signUpFormApi = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/signUp`, 
    options
  ).then(handleAuthResponse);
};